import { useEffect, FunctionComponent } from 'react'
import * as routerActions from 'connected-react-router'
import { useLocation } from 'react-router'
import { useDispatch } from 'react-redux'
import { parse } from 'querystringify'

// Hooks
import { useIsAuthenticated } from 'modules/auth/hooks'
import { useProfile } from 'modules/profile/hooks'

export const UserIsAuthenticatedOrShowLoginComp = ({
  Component,
  props,
  remainOnPath,
  ...rest
}: {
  Component: FunctionComponent
  props: Record<string, unknown>
  remainOnPath?: boolean
}) => {
  const dispatch = useDispatch()
  const isAuthenticated = useIsAuthenticated()
  const { pathname, search } = useLocation()
  const { redirect } = parse(search) as { redirect: string }
  useEffect(() => {
    if (!isAuthenticated && !redirect) {
      const newLocation = `${remainOnPath ? pathname : '/'}?modal=signup&redirect=${encodeURIComponent(pathname + search)}`
      dispatch(routerActions.replace(newLocation))
    }
  }, [pathname, search, isAuthenticated, dispatch, redirect, remainOnPath])
  // NOTE(Kitti): Modal wrapper use ...rest for some reason ...
  return isAuthenticated ? <Component {...{ ...props, ...rest }} /> : null
}

export const UserIsAuthenticatedOrShowLoginForModal = (Component: FunctionComponent) => (props: Record<string, unknown>) =>
  <UserIsAuthenticatedOrShowLoginComp Component={Component} props={props} remainOnPath />

export const UserIsAuthenticatedOrShowLogin = (Component: FunctionComponent) => (props: Record<string, unknown>) =>
  <UserIsAuthenticatedOrShowLoginComp Component={Component} props={props} />

const UserIsAuthenticatedAndStaffRedirComp = ({ Component, props }: { Component: FunctionComponent; props: Record<string, unknown> }) => {
  const dispatch = useDispatch()
  const isAuthenticated = useIsAuthenticated()
  const profile = useProfile()
  const { pathname } = useLocation()

  useEffect(() => {
    if (isAuthenticated) {
      if (!profile.is_staff) {
        dispatch(routerActions.replace('/inspiration/'))
      }
    } else {
      dispatch(routerActions.replace('/'))
    }
  }, [pathname, isAuthenticated, profile.is_staff, dispatch])
  return isAuthenticated ? null : <Component {...props} />
}

export const UserIsAuthenticatedAndStaffRedir = (Component: FunctionComponent) => (props: Record<string, unknown>) =>
  <UserIsAuthenticatedAndStaffRedirComp Component={Component} props={props} />

const UserIsNotAuthenticatedRedirComp = ({ Component, props }: { Component: FunctionComponent; props: Record<string, unknown> }) => {
  const dispatch = useDispatch()
  const isAuthenticated = useIsAuthenticated()

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(routerActions.replace('/inspiration/'))
    }
  }, [isAuthenticated, dispatch])
  return isAuthenticated ? null : <Component {...props} />
}

export const UserIsNotAuthenticatedRedir = (Component: FunctionComponent) => (props: Record<string, unknown>) =>
  <UserIsNotAuthenticatedRedirComp Component={Component} props={props} />
